import Vue from 'vue'
import Router from 'vue-router'
import UserLoginView from './components/UserLogin.vue'
import Authentication from './components/Authentication.vue'
import VerifyEmail from './components/VerifyEmail.vue'
import InviteVerify from './components/InviteVerify.vue'
import UserRegisterView from './components/UserRegister.vue'
import ForgetPassword from './components/ForgetPassword.vue'
import AccountAuthenticationEmail from './components/AccountAuthenticationEmail.vue'
import LetterCompleted from './components/LetterCompleted.vue'
import AccountAuthentication from './components/AccountAuthentication.vue'
import AuthenticationCompleted from './components/AuthenticationCompleted.vue'
import ResetPassword from './components/ResetPassword.vue'
import UpdatePassword from './components/UpdatePassword.vue'
import UpdatePasswordSucess from './components/UpdatePasswordSucess.vue'
import UpdatePasswordContent from './components/UpdatePasswordContent.vue'
import ResetPasswordContent from './components/ResetPasswordContent.vue'

import MyProjectsAddEdit from './views/botApp/botAppAddEdit'
import MyProjectsList from './views/botApp/botAppList'
import MyProjectsVersion from './views/botApp/botAppHistory'
import MyProjectsVersionDetail from './views/botApp/botAppHistory/appDetailView'

// analysis
import AppAnalysis from './components/analysis/AppAnalysis.vue'
import OverView from './components/analysis/OverView.vue'
import Echarts from './components/analysis/echartsTest.vue'
import IndexTest from './components/analysis/IndexTest.vue'
// financial
import FinancialStatistics from './components/financial/FinancialStatistics.vue'
// oder
import OrderManagment from './components/order/OrderManagment.vue'
// info
import InfoBox from './components/info/InfoBox.vue'
// import NotificationSet from './components/info/NotificationSet.vue'
// account
import MyAccount from './components/account/MyAccount.vue'
import UserRoles from './components/account/UserRoles.vue'

Vue.use(Router)
export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
    // my apps
        {
            path: '/myprojects/add',
            component: MyProjectsAddEdit,
            name: 'MyProjectsAdd'
        },
        {
            path: '/myprojects/edit/:appId',
            component: MyProjectsAddEdit,
            name: 'MyProjectsEdit',
            meta: {
                navObj: {
                    type: '1',
                    path: 'MyProjectsEdit',
                    from: 'MyProjectsList'
                }
            }
        },
        {
            path: '/myprojects/list',
            component: MyProjectsList,
            name: 'MyProjectsList',
            meta: {
                navObj: {
                    type: '0',
                    path: 'MyProjectsList',
                    contains: ['MyProjectsEdit', 'MyProjectsVersion', 'MyProjectsVersionDetail']
                }
            }
        },
        {
            path: '/myprojects/version',
            component: MyProjectsVersion,
            name: 'MyProjectsVersion',
            meta: {
                navObj: {
                    type: '1',
                    path: 'MyProjectsVersion',
                    from: 'MyProjectsList'
                }
            }
        },
        {
            path: '/myprojects/version/detail/:id',
            component: MyProjectsVersionDetail,
            name: 'MyProjectsVersionDetail',
            meta: {
                navObj: {
                    type: '1',
                    path: 'MyProjectsVersionDetail',
                    from: 'MyProjectsList'
                }
            }
        },
        // 我的账户
        {
            path: '/myAccount',
            component: MyAccount,
            name: 'myAccount',
            meta: {
                navObj: {
                    type: '2',
                    path: 'myAccount',
                    contains: ['myAccount', 'userRoles']
                }
            }
        },
        // 邀请用户(我的账户1)
        {
            path: '/userRoles',
            component: UserRoles,
            name: 'userRoles',
            meta: {
                navObj: {
                    type: '2',
                    path: 'userRoles',
                    from: 'myAccount'
                }
            }
        },
        // 消息中心
        {
            path: '/infoBox',
            component: InfoBox,
            name: 'infoBox',
            meta: {
                navObj: {
                    type: '2',
                    path: 'infoBox',
                    // contains: ['infoBox', 'notificationSet']
                    contains: ['infoBox']
                }
            }
        },
        // 消息设置
        // {
        //     path: '/notificationSet',
        //     component: NotificationSet,
        //     name: 'notificationSet',
        //     meta: {
        //         navObj: {
        //             type: '2',
        //             path: 'notificationSet',
        //             from: 'infoBox'
        //         }
        //     }
        // },
        // 应用分析
        {
            path: '/appAnalysis',
            component: AppAnalysis,
            name: 'appAnalysis',
            meta: {
                navObj: {
                    type: '0',
                    path: 'appAnalysis',
                    contains: ['echarts', 'indexTest']
                }
            }
        },
        {
            path: '/echarts',
            component: Echarts,
            name: 'echarts',
            meta: {
                navObj: {
                    type: '1',
                    path: 'echarts',
                    from: 'appAnalysis'
                }
            }
        },
        // 应用详细分析1
        {
            path: '/overView',
            component: OverView,
            name: 'overView',
            meta: {
                navObj: {
                    type: '1',
                    path: 'overView',
                    from: 'appAnalysis'
                }
            }
        },
        {
            path: '/indexTest',
            component: IndexTest,
            name: 'indexTest',
            meta: {
                navObj: {
                    type: '1',
                    path: 'indexTest',
                    from: 'appAnalysis'
                }
            }
        },
        // 财务统计
        {
            path: '/financialStatistics',
            component: FinancialStatistics,
            name: 'financialStatistics',
            meta: {
                navObj: {
                    type: '0',
                    path: 'financialStatistics'
                }
            }
        },
        // 订单管理
        {
            path: '/orderManagment',
            component: OrderManagment,
            name: 'orderManagment',
            meta: {
                navObj: {
                    type: '0',
                    path: 'orderManagment'
                }
            }
        },
        // login / register [fu]
        // 登入
        {
            path: '/login',
            component: UserLoginView,
            name: 'userLogin',
            meta: {
                description: 'login',
                requiresAuth: true
            }
        },
        // 选择权限类别
        {
            path: '/user/account/verifyEmail',
            component: VerifyEmail,
            name: 'verifyEmail',
            meta: {
                description: 'verifyEmail',
                requiresAuth: true
            }
        },
        // 详细信息
        {
            path: '/user/register/authentication',
            component: Authentication,
            name: 'authentication',
            meta: {
                description: 'authentication',
                requiresAuth: true
            }
        },
        // 注册
        {
            path: '/user/register',
            component: UserRegisterView,
            name: 'userRegister',
            meta: {
                description: 'userRegister',
                requiresAuth: true
            }
        },
        // 忘记密码
        {
            path: '/user/login/forgetPassword',
            component: ForgetPassword,
            name: 'forgetPassword',
            meta: {
                description: 'forgetPassword',
                requiresAuth: true
            }
        },
        // Account/Email認證Loading layers…
        {
            path: '/user/account/accountAuthenticationEmail',
            component: AccountAuthenticationEmail,
            name: 'accountAuthenticationEmail',
            meta: {
                description: 'accountAuthenticationEmail',
                requiresAuth: true
            }
        },
        // Account/已完成信件認證Loading layers…
        {
            path: '/user/account/letterCompleted',
            component: LetterCompleted,
            name: 'letterCompleted',
            meta: {
                description: 'letterCompleted',
                requiresAuth: true
            }
        },
        // Account/忘記密碼/密碼重設成功Loading layers…
        {
            path: '/user/account/AuthenticationCompleted',
            component: AuthenticationCompleted,
            name: 'authenticationcompleted',
            meta: {
                description: 'authenticationcompleted',
                requiresAuth: true
            }
        },
        // Account/忘記密碼/Email重設密碼Loading layers…
        {
            path: '/user/account/accountAuthentication',
            component: AccountAuthentication,
            name: 'accountAuthentication',
            meta: {
                description: 'accountAuthentication',
                requiresAuth: true
                // secondaryNavState: 'secondaryNavState',
                // thirdNavState: 'thirdNavState'
            }
        },
        // 更新密码
        {
            path: '/user/account/updatePassword',
            component: UpdatePassword,
            name: 'updatePassword',
            meta: {
                description: 'updatePassword',
                requiresAuth: true
            }
        },
        // 重设密码
        {
            path: '/user/account/resetPassword/:id',
            component: ResetPassword,
            name: 'resetPassword',
            meta: {
                description: 'resetPassword',
                requiresAuth: true
            }
        },
        // 更新密码成功
        {
            path: '/user/account/updatePasswordSucess',
            component: UpdatePasswordSucess,
            name: 'updatePasswordSucess',
            meta: {
                description: 'updatePasswordSucess',
                requiresAuth: true
            }
        },
        // 重设密码内容
        {
            path: '/user/account/resetPasswordContent',
            component: ResetPasswordContent,
            name: 'resetPasswordContent',
            meta: {
                description: 'resetPasswordContent',
                requiresAuth: true
            }
        },
        // 更新密码内容
        {
            path: '/user/account/updatePasswordContent',
            component: UpdatePasswordContent,
            name: 'updatePasswordContent',
            meta: {
                description: 'updatePasswordContent',
                requiresAuth: true
            }
        },
        {
            path: '/user/invite/verify',
            component: InviteVerify,
            name: 'inviteVerify'
        }
    ]
})
